// Nama topik generator Matematika untuk halaman admin (bobot topik & statistik).
// Kuncinya harus sama dengan GENERATOR di index.js (dicek di tests/admin.test.js).
// Sengaja terpisah dari generator supaya server tidak perlu memuat semua generator.
const B = 'Bilangan', G = 'Geometri & Pengukuran', D = 'Data';
export const TOPIK_MATEMATIKA = {
  'pecahan-senilai': { nama: 'Pecahan senilai', elemen: B },
  'urutan-pecahan': { nama: 'Membandingkan & mengurutkan pecahan', elemen: B },
  'pecahan-desimal-persen': { nama: 'Pecahan, desimal, dan persen', elemen: B },
  'diskon': { nama: 'Persen & diskon', elemen: B },
  'bilangan-cacah': { nama: 'Operasi bilangan cacah', elemen: B },
  'tambah-kurang-pecahan': { nama: 'Penjumlahan & pengurangan pecahan', elemen: B },
  'kali-bagi-pecahan': { nama: 'Perkalian & pembagian pecahan', elemen: B },
  'kpk': { nama: 'KPK dalam soal cerita', elemen: B },
  'fpb': { nama: 'FPB dalam soal cerita', elemen: B },
  'faktor-kelipatan': { nama: 'Faktor & kelipatan', elemen: B },
  'banding-setengah': { nama: 'Membandingkan dengan setengah', elemen: B },
  'cukup-uang': { nama: 'Uang cukup atau tidak (operasi hitung)', elemen: B },
  'keliling-luas': { nama: 'Keliling & luas bangun datar', elemen: G },
  'luas-bangun': { nama: 'Luas bangun (segitiga, trapesium, gabungan)', elemen: G },
  'sifat-bangun-datar': { nama: 'Sifat bangun datar', elemen: G },
  'volume': { nama: 'Volume kubus & balok', elemen: G },
  'kubus-satuan': { nama: 'Volume dengan kubus satuan', elemen: G },
  'tampak-bangun': { nama: 'Tampak bangun ruang (denah)', elemen: G },
  'dadu': { nama: 'Jaring-jaring dadu', elemen: G },
  'satuan-panjang': { nama: 'Satuan panjang', elemen: G },
  'satuan-berat': { nama: 'Satuan berat', elemen: G },
  'satuan-volume': { nama: 'Satuan volume', elemen: G },
  'muat-wadah': { nama: 'Muat atau tidak (satuan volume)', elemen: G },
  'waktu': { nama: 'Waktu, durasi & kalender', elemen: G },
  'tepat-waktu': { nama: 'Tepat waktu atau terlambat', elemen: G },
  'kecepatan': { nama: 'Kecepatan, jarak, waktu', elemen: G },
  'sudut': { nama: 'Besar sudut', elemen: G },
  'penaksiran': { nama: 'Penaksiran & pembulatan', elemen: G },
  'pembagian-bersisa': { nama: 'Pembagian bersisa (panjang benda)', elemen: G },
  'diagram-batang': { nama: 'Membaca diagram batang', elemen: D },
  'piktogram': { nama: 'Membaca piktogram', elemen: D },
  'tabel-frekuensi': { nama: 'Tabel frekuensi', elemen: D },
  'kesimpulan-data': { nama: 'Menarik kesimpulan dari data', elemen: D },
};
// Daftar topik semua mapel ada di ../topik.js (TOPIK_PER_MAPEL).
